import PropTypes from 'prop-types';

import Card from '@zenbusiness/zui/Card';
import Link from '@zenbusiness/zui/Link';
import Text from '@zenbusiness/zui/Text';

import { getNameInitials } from '#client/utils/formatString';

import * as Styled from './BusinessEntityCard.style';

function BusinessEntityCard({ uuid, name }) {
  return (
    <Card component={Link} to={`/dashboard/${uuid}`}>
      <Styled.CardContent>
        <Styled.Avatar alt={name} variant="square">
          <Text size="xl" color="white" weight="medium">
            {getNameInitials(name)}
          </Text>
        </Styled.Avatar>
        <Text size="lg" color="primary" weight="medium" width="100%">
          {name}
        </Text>
      </Styled.CardContent>
    </Card>
  );
}

BusinessEntityCard.propTypes = {
  uuid: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default BusinessEntityCard;
